"use client";
import { Popper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ColorGray600, SpaceXxs, FontLineHeightMd, FontSize2, SpaceSm, SizeBorderWidthThin, TooltipShadow, ColorGray900, ColorWhite } from "@nxt-costco-com/forge-design-tokens";
import { TOOLTIP_CONTENT_ZINDEX } from "../../Util/zIndex/constants.js";
const StyledButton = styled("button")`
    width: fit-content;
    height: fit-content;
    background-color: transparent;
    border: 0;
    margin: 0;
    padding: 0;
    &:hover {
        cursor: pointer;
        background: transparent;
    }
    &:focus {
        background: transparent;
    }
`;
const TooltipContent = styled(Popper, {
  shouldForwardProp: (prop) => prop !== "sx"
})(() => ({
  maxWidth: "300px",
  backgroundColor: ColorWhite,
  color: ColorGray900,
  boxShadow: TooltipShadow,
  border: `${SizeBorderWidthThin} solid ${ColorGray600}`,
  borderRadius: "0px",
  padding: SpaceSm,
  display: "flex",
  gap: SpaceXxs,
  fontSize: FontSize2,
  lineHeight: FontLineHeightMd,
  margin: `${SpaceXxs} !important`,
  zIndex: TOOLTIP_CONTENT_ZINDEX,
  img: {
    maxWidth: "100%"
  },
  ":focus-visible": { outline: "none" },
  '&[data-popper-placement*="bottom"] .arrow': {
    top: 0,
    left: 0,
    marginTop: "-1.55em",
    marginLeft: 4,
    marginRight: 4,
    "&::before": {
      borderColor: `${ColorGray600} transparent transparent ${ColorGray600}`,
      transformOrigin: "0 100%"
    }
  },
  '&[data-popper-placement*="top"] .arrow': {
    bottom: 0,
    left: 0,
    marginBottom: "-1.55em",
    marginLeft: 4,
    marginRight: 4,
    "&::before": {
      borderColor: `transparent ${ColorGray600} ${ColorGray600} transparent`,
      transformOrigin: "100% 0"
    }
  },
  '&[data-popper-placement*="right"] .arrow': {
    left: 0,
    marginLeft: "-1.55em",
    marginTop: 4,
    marginBottom: 4,
    "&::before": {
      borderColor: `transparent transparent ${ColorGray600} ${ColorGray600}`,
      transformOrigin: "100% 100%"
    }
  },
  '&[data-popper-placement*="left"] .arrow': {
    right: 0,
    marginRight: "-1.55em",
    marginTop: 4,
    marginBottom: 4,
    "&::before": {
      borderColor: `${ColorGray600} ${ColorGray600} transparent transparent`,
      transformOrigin: "0 0"
    }
  }
}));
export {
  StyledButton,
  TooltipContent
};
